import type { GuiaPublica } from "../lib/api";
import { getCategory } from "../lib/categories";
import { Modal } from "./Modal";

interface GuiaPreviewModalProps {
  guia: GuiaPublica;
  onClose: () => void;
  onDownload: () => void;
}

/** Vista previa de la guía PDF antes de descargar */
export function GuiaPreviewModal({ guia, onClose, onDownload }: GuiaPreviewModalProps) {
  const cat = getCategory(guia.categoria);
  return (
    <Modal onClose={onClose} maxWidth={400}>
      <div
        style={{
          aspectRatio: "3/4",
          borderRadius: 14,
          background: `repeating-linear-gradient(135deg, ${cat.bg}, ${cat.bg} 10px, ${cat.bg}cc 10px, ${cat.bg}cc 20px)`,
          border: "1px solid rgba(255,255,255,.6)",
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          gap: 14, padding: 24, textAlign: "center", marginBottom: 20,
        }}
      >
        <img src="/logo-psicodosis.png" alt="" style={{ width: 48, height: 48, objectFit: "contain" }} />
        <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 19, color: "var(--ink-2)" }}>
          {guia.titulo}
        </div>
        <div style={{ fontSize: 12.5, color: "var(--muted-3)" }}>PzicoDosis · {cat.label}</div>
      </div>
      <button onClick={onDownload} className="btn btn-primary btn--full" style={{ marginBottom: 10 }}>
        Descargar gratis ↓
      </button>
      <button onClick={onClose} className="btn btn-outline btn--full">
        Cerrar
      </button>
    </Modal>
  );
}
